const defaultFireflyApiBaseUrl = "http://localhost:8020";
const fireflyApiBaseUrl =
  process.env.FIREFLY_API_BASE_URL ?? defaultFireflyApiBaseUrl;
const fireflyBrowserApiBaseUrl =
  process.env.NEXT_PUBLIC_FIREFLY_API_BASE_URL ?? defaultFireflyApiBaseUrl;

export function buildFireflyApiUrl(
  path: string,
  params: Record<string, string>,
  baseUrl = fireflyApiBaseUrl,
) {
  const url = new URL(path, baseUrl);

  for (const [key, value] of Object.entries(params)) {
    if (value !== "") {
      url.searchParams.set(key, value);
    }
  }

  return url;
}

export function getFireflyApiBaseUrl() {
  return fireflyApiBaseUrl.replace(/\/+$/u, "");
}

export function getFireflyBrowserApiBaseUrl() {
  const baseUrl = new URL(fireflyBrowserApiBaseUrl);
  if (typeof window !== "undefined" && isLoopbackHost(baseUrl.hostname) && isLoopbackHost(window.location.hostname)) {
    baseUrl.hostname = window.location.hostname;
  }
  return baseUrl.toString().replace(/\/+$/u, "");
}

/** 统一 localhost 与 127.0.0.1，避免 SameSite Cookie 被浏览器判定为跨站。 */
function isLoopbackHost(hostname: string) {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

/** 将 GVA 本地上传路径转换为浏览器可访问的站点地址。 */
export function resolveFireflyUploadAssetUrl(value: string) {
  const source = value.trim();
  if (!source) return "";
  if (/^(https?:|data:|blob:)/iu.test(source)) return source;

  return new URL(
    source.replace(/^\/+/, ""),
    `${getFireflyBrowserApiBaseUrl()}/`,
  ).toString();
}

/**
 * 返回浏览器可访问的统一认证中心地址。
 * @returns 去除末尾斜杠的认证中心地址。
 */
export function getFireflyAccountBaseUrl() {
  return (
    process.env.NEXT_PUBLIC_FIREFLY_ACCOUNT_BASE_URL ??
    "https://local-account.t-firefly.com"
  ).replace(/\/+$/u, "");
}

export function getFireflyForumBaseUrl() {
  const forumBaseUrl = (
    process.env.NEXT_PUBLIC_FIREFLY_FORUM_URL ?? "https://forum.t-firefly.com"
  ).replace(/\/+$/u, "");

  return `${forumBaseUrl}/`;
}

export function getFireflyJoinBaseUrl() {
  return (
    process.env.NEXT_PUBLIC_FIREFLY_JOIN_URL ?? "https://join.t-firefly.com"
  ).replace(/\/+$/u, "");
}

export function getFireflyCommunityBaseUrl() {
  return (
    process.env.FIREFLY_COMMUNITY_URL ?? "https://community.t-firefly.com"
  ).replace(/\/+$/u, "");
}

/**
 * 获取英文官网地址。
 * @returns 去除末尾斜杠的英文官网地址。
 */
export function getFireflyEnUrl() {
  return (
    process.env.NEXT_PUBLIC_FIREFLY_EN_URL ?? "https://www.t-firefly.com"
  ).replace(/\/+$/u, "");
}

/**
 * 获取中文官网地址。
 * @returns 去除末尾斜杠的中文官网地址。
 */
export function getFireflyCnUrl() {
  return (
    process.env.NEXT_PUBLIC_FIREFLY_CN_URL ?? "https://www.t-firefly.com.cn"
  ).replace(/\/+$/u, "");
}

/** 前端 public 目录中可作为站内静态资源直出的顶层路径段。 */
const sitePublicRoots = ["community", "docs-assets", "figma-assets", "site"];

/** 判断相对路径是否指向前端 public 目录的站内静态资源。 */
function isSitePublicPath(path: string) {
  const firstSegment = path.replace(/^\/+/u, "").split("/")[0] ?? "";
  return sitePublicRoots.includes(firstSegment);
}

export function resolveFireflyAssetUrl(
  value: string,
  baseUrl = getFireflyBrowserApiBaseUrl(),
) {
  const source = value.trim();
  if (!source) return "";
  if (/^(https?:|data:|blob:)/iu.test(source)) return source;
  // 站内 public 静态资源直接保留原路径，由前端自身服务。
  if (isSitePublicPath(source)) return source;

  return new URL(
    source.replace(/^\/+/u, ""),
    `${baseUrl.replace(/\/+$/u, "")}/`,
  ).toString();
}
